// @ts-nocheck

import { request } from '../context';
import type { ApiOptions } from '../context';
import type { PostSendMsgBody, BaseResponseVoid } from '../types';

/**
 * sendMsg
 *
 * @export
 * @tags 登录
 * @link [POST] /sendMsg
 */
export function postSendMsg(data: PostSendMsgBody): Promise<BaseResponseVoid>;
export function postSendMsg(
    data: PostSendMsgBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseVoid>;
export function postSendMsg(
    data: PostSendMsgBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseVoid> {
    return request<PostSendMsgBody, never, never>('/sendMsg', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postSendMsg',
    });
}

export const meta = [{ tags: ['登录'], path: '/sendMsg', method: 'post' }];
